import compareDesc from 'date-fns/compareDesc';
export const calculationArraySelector = (store) => Object.values(store.calculations.calculations).sort((a, b) => compareDesc(a.updatedOn, b.updatedOn));
export const calculationSelector = (calculationId) => (store) => store.calculations.calculations[calculationId];
export const deletingCalculationsSelector = (store) => store.calculations.deletingCalculations;
